// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

// Components

/**********
 ** Component: IconCopy
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const IconCopy = props => {
	return (
		<Icon
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 38 38"
			width="38"
			height="38"
			aria-labelledby="icon-copy-title"
		>
			<title id="icon-copy-title">{`Copy Code ${props.code} to clipboard`}</title>
			<path
				fill="#7c838a"
				d="M24.14 21a.58.58 0 0 1-.57.57h-5.14a.57.57 0 0 1-.57-.57v-8a.57.57 0 0 1 .57-.57h2.85v1.71a1.15 1.15 0 0 0 1.15 1.14h1.71zm-4 4a.57.57 0 0 1-.57.57h-5.14a.58.58 0 0 1-.57-.57v-8a.58.58 0 0 1 .57-.57H15v-2.28h-.57A2.85 2.85 0 0 0 11.58 17v8a2.85 2.85 0 0 0 2.85 2.85h5.14A2.86 2.86 0 0 0 22.43 25v-.57h-2.29zm5.48-11.64L23.23 11a2.74 2.74 0 0 0-1.95-.81h-2.85A2.86 2.86 0 0 0 15.57 13v8a2.86 2.86 0 0 0 2.86 2.85h5.14A2.85 2.85 0 0 0 26.42 21v-5.71a2.75 2.75 0 0 0-.8-1.94z"
			/>
		</Icon>
	);
};

const Icon = styled.svg`
	display: flex;
	width: ${rem('38px')};
	height: ${rem('38px')};
`;

IconCopy.propTypes = {
	code: PropTypes.string,
};

export default IconCopy;



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/icon-copy.jsx